// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"553":"3dfd80e9","856":"b5503735"}[chunkId] + ".js";
};